import React from 'react';
import { Snackbar, Alert } from '@mui/material';

class ErrorManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            message: '',
            severity: 'error',
        };
    }

    showError(message, severity = 'error') {
        this.setState({ open: true, message, severity });
        setTimeout(() => {
            this.setState({ open: false });
        }, 20000);
    }

    render() {
        return (
            <Snackbar
                open={this.state.open}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                onClose={() => this.setState({ open: false })}
            >
                <Alert severity={this.state.severity} onClose={() => this.setState({ open: false })}>
                    {this.state.message}
                </Alert>
            </Snackbar>
        );
    }
}

export default ErrorManager;
